import { createAction, props } from '@ngrx/store';
import { UserInfo } from '../models/user-info.interface';
import { SharedOrganization } from '../models/shared-organization.interface';
import { OtpInitialization } from '../../../interfaces/otp-initialization.interface';
import { User } from '../../../pages/users-management/store/models/user';

enum AuthActionTypes {
  Login = '[AUTH] Login',
  LoginSuccess = '[AUTH] Login success',
  LoginNeeds2FAInit = '[AUTH] Login needs 2fa init',
  LoginNeeds2FAVerification = '[AUTH] Login needs 2fa verification',
  LoginFailure = '[AUTH] Login failure',
  SetUserInfo = '[AUTH] Set user info',
  SetPermissions = '[AUTH] Set permissions',
  SetToken = '[AUTH] Set token',
  SetRefreshToken = '[AUTH] Set refresh token',
  Logout = '[AUTH] Logout',
  ParseToken = '[AUTH] Parse token',

  RequestPasswordChange = '[AUTH] Request password change',
  RequestPasswordChangeSuccess = '[AUTH] Request password change success',
  RequestPasswordChangeFailure = '[AUTH] Request password change failure',

  SwitchOrganization = '[AUTH] Switch organization',
  SwitchOrganizationSuccess = '[AUTH] Switch organization success',
  SwitchOrganizationFailure = '[AUTH] Switch organization failure',
  UpdatePermissions = '[AUTH] Update permissions',
  UpdatePermissionsSuccess = '[AUTH] Update permissions success',
  SetSharedOrgsSuccess = '[AUTH] Set shared orgs',

  GetOtpInitData = '[AUTH] Get otp init data',
  GetOtpInitDataSuccess = '[AUTH] Get otp init data success',
  GetOtpInitDataFailure = '[AUTH] Get otp init data failure',

  toggle2FA = '[AUTH] Toggle 2FA',
  toggle2FASuccess = '[AUTH] Toggle 2FA success',
  toggle2FAFailure = '[AUTH] Toggle 2FA failure',

  verify2FACode = '[AUTH] Verify 2FA code',
  verify2FACodeSuccess = '[AUTH] Verify 2FA code success',
  verify2FACodeFailure = '[AUTH] Verify 2FA code failure',

  disable2FA = '[AUTH] Disable 2FA',
  disable2FASuccess = '[AUTH] Disable 2FA success',
  disable2FAFailure = '[AUTH] Disable 2FA failure',

  updateProfile = '[AUTH] Update profile',
  updateProfileSuccess = '[AUTH] Update profile success',
  updateProfileFailure = '[AUTH] Update profile failure',

  reset = '[AUTH] Reset auth store',
}

export const login = createAction(
  AuthActionTypes.Login,
  props<{ username: string, password: string, otp_code?: string }>(),
);

export const loginSuccess = createAction(
  AuthActionTypes.LoginSuccess,
  props<{ token: string, refreshToken?: string, requestPasswordChange?: boolean }>(),
);

export const loginNeeds2FAInit = createAction(
  AuthActionTypes.LoginNeeds2FAInit,
  props<{ secret: string; qr: string }>(),
);

export const loginNeeds2FAVerification = createAction(
  AuthActionTypes.LoginNeeds2FAVerification,
);

export const loginFailure = createAction(
  AuthActionTypes.LoginFailure,
  props<{ error: string }>(),
);

export const setUserInfo = createAction(
  AuthActionTypes.SetUserInfo,
  props<{ userInfo: Partial<UserInfo> }>(),
);

export const setToken = createAction(
  AuthActionTypes.SetToken,
  props<{ token: string }>(),
);

export const setRefreshToken = createAction(
  AuthActionTypes.SetRefreshToken,
  props<{ refreshToken: string }>(),
);

export const setPermissions = createAction(
  AuthActionTypes.SetPermissions,
  props<{ permissions: Array<string> }>(),
);

export const logout = createAction(
  AuthActionTypes.Logout,
);

export const parseToken = createAction(
  AuthActionTypes.ParseToken,
  props<{ token: string }>(),
);

export const requestPasswordChange = createAction(
  AuthActionTypes.RequestPasswordChange,
  props<{ newPassword: string, oldPassword: string }>(),
);

export const requestPasswordChangeSuccess = createAction(
  AuthActionTypes.RequestPasswordChangeSuccess,
);

export const requestPasswordChangeFailure = createAction(
  AuthActionTypes.RequestPasswordChangeFailure,
  props<{ error: string }>(),
);

export const switchOrganization = createAction(
  AuthActionTypes.SwitchOrganization,
  props<{ id: string }>(),
);

export const switchOrganizationSuccess = createAction(
  AuthActionTypes.SwitchOrganizationSuccess,
  props<{ token: string, refreshToken: string }>(),
);

export const switchOrganizationFailure = createAction(
  AuthActionTypes.SwitchOrganizationFailure,
  props<{ error: string }>(),
);

export const updatePermissions = createAction(
  AuthActionTypes.UpdatePermissions,
);

export const updatePermissionsSuccess = createAction(
  AuthActionTypes.UpdatePermissionsSuccess,
  props<{ permissions: string[] }>(),
);

export const setSharedOrgs = createAction(
  AuthActionTypes.SetSharedOrgsSuccess,
  props<{ sharedOrganizations: SharedOrganization[] }>(),
);

export const getOtpInitData = createAction(
  AuthActionTypes.GetOtpInitData,
);

export const getOtpInitDataSuccess = createAction(
  AuthActionTypes.GetOtpInitDataSuccess,
  props<OtpInitialization>(),
);

export const getOtpInitDataFailure = createAction(
  AuthActionTypes.GetOtpInitDataFailure,
);

export const updateProfile = createAction(
  AuthActionTypes.updateProfile,
  props<{ id: string, data: Partial<User> }>(),
);

export const updateProfileSuccess = createAction(
  AuthActionTypes.updateProfileSuccess,
);

export const updateProfileFailure = createAction(
  AuthActionTypes.updateProfileFailure,
);

export const toggle2FA = createAction(
  AuthActionTypes.toggle2FA,
  props<{ id: string, data: Partial<User> }>(),
);

export const toggle2FASuccess = createAction(
  AuthActionTypes.toggle2FASuccess,
);

export const toggle2FAFailure = createAction(
  AuthActionTypes.toggle2FAFailure,
);

export const verify2FACode = createAction(
  AuthActionTypes.verify2FACode,
  props<{ code: string }>(),
);

export const verify2FACodeSuccess = createAction(
  AuthActionTypes.verify2FACodeSuccess,
);

export const verify2FACodeFailure = createAction(
  AuthActionTypes.verify2FACodeFailure,
);

export const disable2FA = createAction(
  AuthActionTypes.disable2FA,
  props<{ code: string }>(),
);

export const disable2FASuccess = createAction(
  AuthActionTypes.disable2FASuccess,
);

export const disable2FAFailure = createAction(
  AuthActionTypes.disable2FAFailure,
);

export const reset = createAction(
  AuthActionTypes.reset,
);
